module.exports = __webpack_public_path__ + "static/media/logo.9bd1e278.png";